import { ConditionalType, ConditionEvent, NodeTriggerType, type TriggerData } from "@regal-voice/shared-types";

export type ParsedEventFiltersMetadata = {
    eventType?: ConditionalType | NodeTriggerType;
    eventName?: string;
    filtersCount: number;
};

export function getMetadataFromTriggerFilterEvent(triggerData: any): ParsedEventFiltersMetadata {
    const firstEvent: ConditionEvent = triggerData.triggerFiltersEvents?.[0]?.conditions[0];
    return {
        eventType: firstEvent?.conditionalType,
        eventName: firstEvent?.eventName,
        filtersCount: firstEvent?.filters?.length || 0,
    };
}

/** Normalize legacy top-level trigger fields vs modern triggerFiltersEvents shape. */
export function parseTriggerNodeData(triggerNode: any): TriggerData {
    const triggerData = triggerNode?.data;
    if (!!triggerData?.triggerFiltersEvents) {
        return {
            ...triggerData,
            ...getMetadataFromTriggerFilterEvent(triggerData),
        };
    }
    return triggerData;
}
